import type {
	MappedHttpRequest,
	HttpRequest,
} from "../core/types";
import { BaseErrorUtility } from "../core/baseUtility";

// TODO: Refactor this
export class CloudflareErrorUtility extends BaseErrorUtility<HttpRequest>
{
	protected async mapRequest(req: HttpRequest): Promise<MappedHttpRequest> {
		return {
			method: req.method?.toUpperCase() ?? null,
			url: req.url ?? null,
			requestBody: req.body,
			query: req.query ?? null,
			headers: req.headers ?? null,
		};
	}
}
